import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import {
  IconButton,
  Dialog,
  DialogContent,
  DialogTitle
} from '@material-ui/core'
import { ICON_NAMES } from '../../../../constants'
import Icon from '../../../atoms/Icon'
import AccountsList from './AccountsList'

const useStyles = makeStyles(() => ({
  dialog: {
    position: 'relative'
  },
  paper: {
    maxWidth: '868px',
    borderRadius: '20px',
    padding: '27px 20px 27px'
  },
  close: {
    position: 'absolute',
    top: '23px',
    right: '23px'
  },
  content: {
    padding: '0px 12px 12px'
  }
}))

const ClientModalAccounts = ({
  handleClose,
  open
}) => {
  const classes = useStyles()

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      classes={{
        root: classes.dialog,
        paper: classes.paper
      }}
    >
      <IconButton
        onClick={handleClose}
        color='inherit'
        classes={{
          root: classes.close
        }}
      >
        <Icon name={ICON_NAMES.close} customSize='1.5rem' />
      </IconButton>
      <DialogTitle id='alert-dialog-title'>Accounts</DialogTitle>
      <DialogContent classes={{
        root: classes.content
      }}
      >
        <AccountsList />
      </DialogContent>
    </Dialog>
  )
}

ClientModalAccounts.propTypes = {
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired
}

export default ClientModalAccounts
